export default __webpack_public_path__ + "static/media/gold_banner.aee9849d.svg";